<template>
  <ODialog ref="dialog" :maxWidth="1200">
    <v-card v-if="!isLoading">
      <v-toolbar class="card-bar">
        <v-toolbar-title>(db: {{ db }}) /{{ key }}</v-toolbar-title>
        <v-spacer />
        <v-btn icon @click="$refs.dialog.$dismiss()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text class="pa-3 maxh-6" v-if="value != null">
        <v-expansion-panels
          v-if="isArray"
          accordion
          multiple
          focusable
          hover
          tile
          class="mb-4"
        >
          <v-expansion-panel v-for="(item, i) in value" :key="i">
            <v-expansion-panel-header> Item #{{ i }} </v-expansion-panel-header>
            <v-expansion-panel-content class="noPaddingExpansionPanel">
              <pre class="scroll-x">{{ item | prettyJson }}</pre>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <pre v-else class="scroll-x">{{ value | prettyJson }}</pre>
      </v-card-text>

      <v-card-actions class="pa-6">
        <v-spacer />
        <OHoldToConfirm color="error" @confirmed="emitDelete">
          Apagar...
        </OHoldToConfirm>
      </v-card-actions>
    </v-card>
  </ODialog>
</template>

<script>
import _ from 'lodash'
import { Redis } from '@/models'

function maybeParse(x) {
  if (x != null && _.isString(x) && (x[0] == '{' || x[0] == '[')) {
    return JSON.parse(x)
  }
  return x
}

export default {
  mixins: [require('oderon-vue/cpts/dialog-promise-mixin').default],
  components: {
    OHoldToConfirm: require('oderon-vue/cpts/OHoldToConfirm').default,
    ODialog: require('oderon-vue/cpts/ODialog').default
  },
  data() {
    return this.reset()
  },
  computed: {
    isArray() {
      return this.value != null && _.isArray(this.value)
    }
  },
  methods: {
    reset() {
      return {
        isLoading: false,
        db: null,
        key: null,
        value: null
      }
    },

    async open(db, key) {
      Object.assign(this, this.reset())
      this.db = db
      this.key = key
      this.$loading(() => this.fetchData())
      return this.$refs.dialog.$open()
    },

    async fetchData() {
      // await this.$delay(2000)
      let value = await Redis.findOne(this.db, this.key)
      value = maybeParse(value)

      if (_.isArray(value)) value = value.map(v => maybeParse(v))

      this.value = value
    },

    emitDelete() {
      this.$refs.dialog.$apply('DELETE')
    }
  }
}
</script>

<style>
.scroll-x {
  overflow-x: auto;
  white-space: pre-wrap;
}
</style>
